// addTodeal.jsx - REDESIGN COMPLET ULTRA PROFESSIONNEL
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { FiX, FiPercent, FiTag, FiTrendingUp, FiAlertCircle } from "react-icons/fi";
import { MdLocalOffer } from "react-icons/md";
import Card from '../pageInside/CardOrders';
import { AddToDealToDay } from "../auth/apiProduct";
import './addTodeal.css';
import { isAuthenticated } from "../auth";
import { elakayAutoText } from "../pageInside/dataElakay";
import { getProductPrimaryImage } from "../auth/elakay-utils";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addTodeal"]?.[key] || fallback;

class AddToDealModern extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salePrice: 3,
      show: true,
      isSubmitting: false,
      error: null,
      success: false
    };
  }

  handleChange = (event) => {
    const value = parseInt(event.target.value) || 0;
    this.setState({ 
      salePrice: value,
      error: null 
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    
    const { salePrice } = this.state;
    
    // Validation
    if (salePrice < 3) {
      this.setState({ error: __elakayText("t007", "Discount must be at least 3%") });
      return;
    }
    
    if (salePrice > 90) {
      this.setState({ error: __elakayText("t008", "Discount cannot exceed 90%") });
      return;
    }

    const {
      loadProductsByArrival,
      myFilters = { filters: { "categoriesID.gategoriesLink": [] } },
      productaddToDeal,
      getFilterUserProd,
      DealProduct
    } = this.props;

    const { token } = isAuthenticated();

    this.setState({ isSubmitting: true, error: null });

    AddToDealToDay(token, productaddToDeal._id, {
      "dealTodays": true,
      "discount": salePrice
    }).then(data => {
      if (data.error) {
        this.setState({ 
          error: data.error,
          isSubmitting: false 
        });
      } else {
        this.setState({ 
          success: true,
          isSubmitting: false 
        });
        
        // Refresh product list
        loadProductsByArrival(
          token,
          DealProduct,
          myFilters,
          getFilterUserProd
        );

        // Auto-close after success
        setTimeout(() => {
          this.props.buttonDealB();
        }, 1500);
      }
    }).catch(err => {
      this.setState({ 
        error: __elakayText("t009", "An error occurred. Please try again."),
        isSubmitting: false 
      });
    });
  };

  calculateDiscountedPrice = () => {
    const { productaddToDeal } = this.props;
    const { salePrice } = this.state;
    
    if (!productaddToDeal || !productaddToDeal.price) return 0;
    
    const originalPrice = parseFloat(productaddToDeal.price);
    const discountAmount = (originalPrice * salePrice) / 100;
    return (originalPrice - discountAmount).toFixed(2);
  };

  render() {
    const {
      infoSource,
      productaddToDeal,
      buttonDealB,
      show
    } = this.props;

    const { salePrice, isSubmitting, error, success } = this.state;

    __setElakayInfoSource(infoSource);

    // Language API
    let ilcod = infoSource.languageAPI.checkLangObjDefault;
    let ileia = infoSource.languageAPI.elakayInfoAPI;
    let ilei = infoSource.languageAPI.elakayInfo;

    let InfoApiButton = !infoSource.loading && ilcod(ileia, ilei, 'Button');
    let InfoApiLabel = !infoSource.loading && ilcod(ileia, ilei, 'label');

    // Product data
    const data = {
      name: productaddToDeal ? productaddToDeal.name : "",
      price: productaddToDeal ? productaddToDeal.price : "",
      item: productaddToDeal,
      salePrice: salePrice
    };

    const url = show ? getProductPrimaryImage(productaddToDeal) : "";
    const originalPrice = productaddToDeal?.price || 0;
    const discountedPrice = this.calculateDiscountedPrice();
    const savings = (originalPrice - discountedPrice).toFixed(2);

    // Progress bar percentage (3% = 0%, 90% = 100%)
    const progressPercentage = ((salePrice - 3) / (90 - 3)) * 100;

    return (
      <Modal
        show={show}
        onHide={buttonDealB}
        centered
        dialogClassName="deal-modal-dialog"
        contentClassName="deal-modal"
        backdropClassName="deal-modal-backdrop"
      >
        {/* Header */}
        <Modal.Header className="deal-modal-header">
          <div className="deal-header-icon">
            <MdLocalOffer />
          </div>
          <div className="deal-header-content">
            <Modal.Title as="h3" className="deal-modal-title">
              {InfoApiLabel?.AddDeal || elakayAutoText("h_097965c0330482", "Add to Today's Deal")}
            </Modal.Title>
            <p className="deal-modal-subtitle">{__elakayText("t001", "Set discount and promote this product")}</p>
          </div>
          <button
            className="deal-close-btn"
            onClick={buttonDealB}
            aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t001}
          >
            <FiX />
          </button>
        </Modal.Header>

        {/* Body */}
        <Modal.Body className="deal-modal-body">

              {/* Product preview */}
              <div className="deal-product-preview">
                <Card
                  urlImg={url}
                  product={data}
                />
              </div>

              {/* Discount form */}
              <form className="deal-form" onSubmit={this.handleSubmit}>
                
                {/* Discount slider section */}
                <div className="deal-discount-section">
                  <label className="deal-label">
                    <FiPercent className="deal-label-icon" />
                    <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t002}</span>
                  </label>

                  {/* Range slider */}
                  <div className="deal-slider-container">
                    <input
                      type="range"
                      min="3"
                      max="90"
                      value={salePrice}
                      onChange={this.handleChange}
                      className="deal-slider"
                      style={{
                        background: `linear-gradient(to right, #4facfe 0%, #4facfe ${progressPercentage}%, #e2e8f0 ${progressPercentage}%, #e2e8f0 100%)`
                      }}
                    />
                    <div className="deal-slider-labels">
                      <span className="deal-slider-min">3%</span>
                      <span className="deal-slider-max">90%</span>
                    </div>
                  </div>

                  {/* Number input */}
                  <div className="deal-input-group">
                    <div className="deal-input-icon">
                      <FiPercent />
                    </div>
                    <input
                      type="number"
                      min="3"
                      max="90"
                      value={salePrice}
                      onChange={this.handleChange}
                      className="deal-input"
                      placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t003}
                    />
                    <div className="deal-input-badge">
                      {salePrice}{__elakayText("t002", "% OFF")}</div>
                  </div>

                  {/* Helper text */}
                  <div className="deal-helper-text">
                    <FiAlertCircle />
                    <span>
                      {InfoApiLabel?.dealNumberMore3 || elakayAutoText("h_b9bcfb64e832a4", "Discount must be between 3% and 90%")}
                    </span>
                  </div>
                </div>

                {/* Price preview */}
                <div className="deal-price-preview">
                  <div className="deal-price-card">
                    <div className="deal-price-row">
                      <span className="deal-price-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t004}</span>
                      <span className="deal-price-value original">
                        ${parseFloat(originalPrice).toFixed(2)}
                      </span>
                    </div>
                    
                    <div className="deal-price-row highlight">
                      <span className="deal-price-label">
                        <FiTag className="deal-price-icon" />{__elakayText("t003", "Discounted Price:")}</span>
                      <span className="deal-price-value discounted">
                        ${discountedPrice}
                      </span>
                    </div>

                    <div className="deal-price-row savings">
                      <span className="deal-price-label">
                        <FiTrendingUp className="deal-price-icon" />{__elakayText("t004", "Customer Saves:")}</span>
                      <span className="deal-price-value saved">
                        ${savings}
                      </span>
                    </div>
                  </div>

                  {/* Discount badge preview */}
                  <div className="deal-badge-preview">
                    <div className="deal-badge-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t005}</div>
                    <div className="deal-badge-sample">
                      <span className="deal-badge-percent">{salePrice}%</span>
                      <span className="deal-badge-text">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t006}</span>
                    </div>
                  </div>
                </div>

                {/* Error message */}
                {error && (
                  <div className="deal-alert deal-alert-error">
                    <FiAlertCircle />
                    <span>{error}</span>
                  </div>
                )}

                {/* Success message */}
                {success && (
                  <div className="deal-alert deal-alert-success">
                    <FiTag />
                    <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).includesDwawerAddTodeal.t007}</span>
                  </div>
                )}

                {/* Actions */}
                <div className="deal-modal-actions">
                  <button
                    type="button"
                    className="deal-btn deal-btn-secondary"
                    onClick={buttonDealB}
                    disabled={isSubmitting}
                  >{__elakayText("t010", "Cancel")}</button>
                  <button
                    type="submit"
                    className="deal-btn deal-btn-primary"
                    disabled={salePrice < 3 || isSubmitting || success}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="deal-spinner"></span>{__elakayText("t005", "Processing...")}</>
                    ) : success ? (
                      <>
                        <FiTag />{__elakayText("t006", "Added to Deals!")}</>
                    ) : (
                      <>
                        <MdLocalOffer />
                        {InfoApiButton?.edit || elakayAutoText("h_b1f6e425255371", "Add to Deal")}
                      </>
                    )}
                  </button>
                </div>
              </form>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AddToDealModern;
